<template>
  <div class="flex flex-col h-full justify-between pl-4 space-y-4 w-[23rem]">
    <app-sidebar-org-card />

    <app-sidebar-role-card />
  </div>
</template>

<script>
import AppSidebarOrgCard from './subcomponents/AppSidebarOrgCard';
import AppSidebarRoleCard from './subcomponents/AppSidebarRoleCard';

export default {
  name: 'AppSidebarContent',

  components: { AppSidebarOrgCard, AppSidebarRoleCard },
};
</script>
